import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CircularProgress, Box } from '@mui/material';

interface Props {
  dataLength: number;
  hasMore: boolean;
  next: () => void;
  loader?: React.ReactNode;
  children: React.ReactNode;
  scrollableTarget?: string;
  height?: string | number;
}

const InfiniteScrollWrapper = ({ dataLength, hasMore, next, loader, children, scrollableTarget }: Props) => {
  return (
    <InfiniteScroll
      dataLength={dataLength}
      hasMore={hasMore}
      next={next}
      loader={
        loader || (
          <Box textAlign="center" mt={2}>
            <CircularProgress size={24} />
          </Box>
        )
      }
      scrollableTarget={scrollableTarget}
      scrollThreshold={0.9}
      style={{ overflow: 'hidden' }}
    >
      {children}
    </InfiniteScroll>
  );
};

export default InfiniteScrollWrapper;
